import React from "react";
import { CERTIFICATIONS } from "../data/mock";

export default function Certifications() {
  return (
    <section className="relative py-20 md:py-24 bg-[#0a1f55] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "42px 42px",
        }}
      ></div>
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#f59e0b]/20 blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12 reveal">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
            Accreditamenti e Certificazioni
          </div>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-white">
            Riconosciuti, qualificati, certificati.
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-slate-300">
            ACDT opera in conformità alla Legge 4/2013 e fa parte della rete di aggregazione MIMIT,
            insieme a partner formativi di eccellenza.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {CERTIFICATIONS.map((c, i) => (
            <div
              key={c.title}
              className="reveal rounded-2xl bg-white/[0.04] border border-white/10 backdrop-blur-sm p-7 hover:bg-white/[0.07] hover:border-[#f59e0b]/40 transition-all duration-300"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="h-32 w-full rounded-xl bg-white flex items-center justify-center p-3 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="max-h-full max-w-full object-contain"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <h3 className="mt-5 text-lg font-bold text-white">{c.title}</h3>
              <p className="mt-2 text-[14px] text-slate-300 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
